import React from "react";

// set the defaults
const ContentContext = React.createContext({
    contentState: "en",
    setContentState: () => {}
});

export default ContentContext;